import { gql } from '@apollo/client';
import { INVENTORY_OPTION_MATCH_FRAGMENT } from 'modules/inventoryOptions';

export const GET_EQUIPMENT_DETAILS_BY_ID = gql`
  query GetEquipmentDetailsById($id: ID!) {
    equipment: equipmentById(id: $id) {
      equipmentId
      year
      make
      model
      modelBase
      stockId
      serialNumberVin
      newUsed
      mileage
      classType
      truckClass
      assetTypeStr
      type
      style
      hours
      additionalDescription
      wholesaleCost
      totalWholesaleCost
      retailPrice
      discountType
      discountValue
      quantity
      createdDateTime
      modifiedDateTime
      attachments
      specs
      assets {
        id
        source
        type
        createdDateTime
      }
      inventoryItem {
        inventoryId
        status
        condition
      }
      options {
        ...InventoryOptionMatchFields
      }
    }
  }
  ${INVENTORY_OPTION_MATCH_FRAGMENT}
`;
